// File: src/components/pages/Templates.jsx
// Tab-based page with Configuration tab as first tab

import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Calendar } from 'lucide-react';
import SlotTemplates from '../SlotTemplates';
import Publish from './Publish';
import InstructorConfiguration from './InstructorConfiguration';
import { AUTH0_NAMESPACE } from '../../utils/constants';
import '../../styles/templates.css';

export default function Templates() {
  const { user } = useAuth0();
  const [activeTab, setActiveTab] = useState('templates');

  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];
  const isServiceProvider = userRoles.includes('ServiceProvider');

  // Configuration tab first (only for ServiceProvider)
  const instructorTabs = isServiceProvider 
    ? [{ id: 'configuration', label: 'Configuration' }]
    : [];

  // Base tabs visible to all users
  const baseTabs = [
    { id: 'templates', label: 'Templates' },
    { id: 'publish', label: 'Publish' },
    { id: 'activate', label: 'Activate' },
    { id: 'changes', label: 'Changes' }
  ];

  // Configuration tab appears first
  const tabs = [...instructorTabs, ...baseTabs];

  return (
    <div className="page-container">
      {/* Page Header 
      <div className="page-header">
        <div className="page-title-wrapper">
          <Calendar className="page-icon" size={32} />
          <h1 className="page-title">Slot Template</h1>
        </div>
      </div>
      */}
      {/* Tab Navigation */}
      <div className="tab-navigation">
        <div className="tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? 'tab-active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content-wrapper">
        {/* Configuration Tab - Only for ServiceProvider (appears first) */}
        {activeTab === 'configuration' && (
          <InstructorConfiguration />
        )}

        {/* Templates Tab - Reuse existing component */}
        {activeTab === 'templates' && (
          <SlotTemplates />
        )}

        {/* Publish Tab */}
        {activeTab === 'publish' && (
          <Publish />
        )}

        {/* Activate Tab */}
        {activeTab === 'activate' && (
          <div className="tab-content-placeholder">
            <h2>Activate Template</h2>
            <p>Activate or deactivate your templates</p>
            {/* TODO: Implement Activate component */}
          </div>
        )}

        {/* Changes Tab */}
        {activeTab === 'changes' && (
          <div className="tab-content-placeholder">
            <h2>Change History</h2>
            <p>View history of changes made to your templates</p>
            {/* TODO: Implement Changes/History component */}
          </div>
        )}
      </div>
    </div>
  );
}